/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./BaseSelectField.vue?vue&type=template&id=87a2fba4"
import script from "./BaseSelectField.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseSelectField.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BaseSelectField.vue?vue&type=style&index=0&id=87a2fba4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports